import dataLayer, { type DataLayer } from 'assets/core/js/module/dataLayer'

type products = Record<number, Record<string, object>>

export default function (): void {
  dataLayer.pushOnElementVisible(
    window.coreGtmId,
    document.querySelectorAll(
      '[data-pagetype~="search"] .search-results-list .search-result > [data-id], [data-pagetype~="search"] .dca-results__list .dca-result[data-id], [data-pagetype~="search"] .results__list > [data-id]'
    ),
    (data, els) => {
      const products: object[] = []
      for (const el of els) {
        const dataId = el.getAttribute('data-id')
        if (dataId === null) {
          continue
        }
        const productId = parseInt(dataId, 10)
        if (!data.products) {
          continue
        }
        const product = (data.products as products)[productId]
        if (product) {
          const productKey = Object.keys(product)[0]
          if (productKey !== undefined) {
            const productData = product[productKey]
            if (productData !== undefined) {
              products.push(productData) // data are nested, we extract just data, ignore key
            }
          }
        }
      }
      if (!products.length) {
        return false
      }

      return {
        event: dataLayer.events.SEARCH_VIEW_PRODUCTS,
        item_list_name: data.searchType,
        products,
      }
    }
  )

  dataLayer.pushOnCustomEvent(window.coreGtmId, window, 'productPageLink.opened', function (data, _el, domEvent) {
    if (!(domEvent instanceof CustomEvent) || domEvent.detail === null || typeof domEvent.detail !== 'object') {
      return false
    }

    const productId = (domEvent.detail as { productId: number }).productId
    const products = data.products as products
    if (!products?.[productId]) {
      return false
    }

    const product = products[productId]
    if (!product) {
      return false
    }

    const eventData = {
      event: dataLayer.events.SEARCH_SELECT_PRODUCT,
      item_list_name: data.searchType,
    }
    Object.assign(eventData, product)

    return eventData
  })

  pushSearchResultsData()
}

const pushSearchResultsData = (): void => {
  // New search events.
  const searchResultsDataRaw = document.querySelector('#search-datalyer-search-results')?.textContent ?? ''
  let searchResultsData: DataLayer | undefined
  try {
    const parsedData = JSON.parse(searchResultsDataRaw)
    if (parsedData !== null && parsedData !== undefined && parsedData !== false) {
      searchResultsData = parsedData as DataLayer
    }
  } catch {
    // Silently handle parsing errors (invalid JSON or empty content).
  }
  if (searchResultsData) {
    dataLayer.pushInLayer(window.coreGtmId, searchResultsData)
  }
}
